import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    rating: (value: number) => `Оценка ${value} из 5`,
    loadFailed: 'Не удалось загрузить отзывы',
    retry: 'Повторить',
    empty: 'Ой, отзывов пока нет…',
    learner: 'Ученик',
    loading: 'Загрузка…',
    showMore: 'Показать ещё',
  },
  en: {
    rating: (value: number) => `Rated ${value} out of 5`,
    loadFailed: 'Couldn’t load reviews',
    retry: 'Retry',
    empty: 'Oops, no reviews yet…',
    learner: 'Learner',
    loading: 'Loading…',
    showMore: 'Show more',
  },
})
